import React from 'react';
import SharedSpinnerLoad from 'shared_items/SpinnerLoad';

// Shim de compatibilidade — implementação real em shared_items/SpinnerLoad.jsx (design-system fase 1).
// Mantém a mesma interface (incluindo `size`) p/ não quebrar imports existentes; remover em fase 3.
const SpinnerLoad = (props) => <SharedSpinnerLoad moduleKey="planner" {...props} />;

export default SpinnerLoad;
